<template>
  <div class="body d-flex py-lg-3 pb-5 py-md-2">
    <div class="container px-0">
      <div class="row clearfix">
        <div class="col-md-12">
          <div class="d-flex">
            <!-- Table Column -->
            <div :class="{ 'col-md-12': !showFilters, 'col-md-9 leftCol': showFilters }">
              <div class="card-body ">
                <div id="projectTableMobile" class="d-flex w-100">
                  <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-column justify-content-center align-items-center mb-3">
                      <div class="d-flex flex-row justify-content-space-between gap-5 mb-3">
                        <div>
                          <span>Από: </span>
                          <input type="date" id="start-date" v-model="startDate" class="date-input">
                          <label for="start-date" class="calendar-icon fs-3 ms-1">
                            <i class="icofont-calendar"></i>
                          </label>
                        </div>
                        <div>
                          <span>Εώς: </span>
                          <input type="date" id="end-date" v-model="endDate" class="date-input">
                          <label for="end-date" class="calendar-icon fs-3 ms-1">
                            <i class="icofont-calendar"></i>
                          </label>
                        </div>
                      </div>
                      <div>
                        <!-- Entity Tabs for mobile -->
                      <ul class="nav nav-tabs tab-body-header rounded w-100 gap-3 mb-2 justify-content-center" role="tablist">
                        <li class="nav-item">
                          <a
                            :class="{
                              'nav-link text-center active': filters.entity == 'all',
                              'nav-link text-center': filters.entity != 'all',
                            }"
                            @click.prevent="() => updateFilters({ ...filters, entity: 'all', page: 1 })"
                            href="#"
                            role="tab"
                          >
                            <strong>All</strong>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            :class="{
                              'nav-link text-center active': filters.entity == 'projects',
                              'nav-link text-center': filters.entity != 'projects',
                            }"
                            @click.prevent="() => updateFilters({ ...filters, entity: 'projects', page: 1 })"
                            href="#"
                            role="tab"
                          >
                            <strong>P</strong>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            :class="{
                              'nav-link text-center active': filters.entity == 'tasks' || filters.entity == undefined,
                              'nav-link text-center': filters.entity != 'tasks',
                            }"
                            @click.prevent="() => updateFilters({ ...filters, entity: 'tasks', page: 1 })"
                            href="#"
                            role="tab"
                          >
                            <strong>T</strong>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            :class="{
                              'nav-link text-center active': filters.entity == 'subtasks',
                              'nav-link text-center': filters.entity != 'subtasks',
                            }"
                            @click.prevent="() => updateFilters({ ...filters, entity: 'subtasks', page: 1 })"
                            href="#"
                            role="tab"
                          >
                            <strong>S</strong>
                          </a>
                        </li>
                      </ul>
                        <ul class="nav nav-tabs tab-body-header rounded w-100 gap-3 mb-2 justify-content-center" role="tablist">
                          <li class="nav-item">
                            <a :class="{ 'nav-link text-center active': filters.statusId == '10' , 'nav-link text-center': filters.statusId != '10' && filters.statusId != undefined }"
                              @click.prevent="() => updateFilters({ ...filters, statusId: '10', page: 1 })" href="#"
                              role="tab">
                              <strong>All</strong>
                            </a>
                          </li>

                         
                          <li class="nav-item">
                            <a :class="{ 'nav-link text-center active': filters.statusId == '2' || filters.statusId == undefined, 'nav-link text-center': filters.statusId != '2' }"
                              @click.prevent="() => updateFilters({ ...filters, statusId: '2', page: 1 })" href="#"
                              role="tab">
                              <span class="wx-st wx-st-progress" title="In Progress">In progress</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a :class="{ 'nav-link text-center active': filters.statusId == '3', 'nav-link text-center': filters.statusId != '3' }"
                              @click.prevent="() => updateFilters({ ...filters, statusId: '3', page: 1 })" href="#"
                              role="tab">
                              <span class="wx-st wx-st-done" title="Done">Done</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a :class="{ 'nav-link text-center active': filters.statusId == '1', 'nav-link text-center': filters.statusId != '1' }"
                              @click.prevent="() => updateFilters({ ...filters, statusId: '1', page: 1 })" href="#"
                              role="tab">
                              <span class="wx-st wx-st-hold" title="On Hold">On hold</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a :class="{ 'nav-link text-center active': filters.statusId == '5', 'nav-link text-center': filters.statusId != '5' }"
                              @click.prevent="() => updateFilters({ ...filters, statusId: '5', page: 1 })" href="#"
                              role="tab">
                              <span class="wx-st wx-st-ongoing" title="On going">On going</span>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a :class="{ 'nav-link text-center active': filters.statusId == '4', 'nav-link text-center': filters.statusId != '4' }"
                              @click.prevent="() => updateFilters({ ...filters, statusId: '4', page: 1 })" href="#"
                              role="tab">
                              <span class="wx-st wx-st-archived" title="Archived">Archived</span>
                            </a>
                          </li>
                          <li v-if="filters.entity === 'projects'">
                            <a :class="{ 'nav-link text-center active': filters.statusId == '6', 'nav-link text-center': filters.statusId != '6' }"
                              @click.prevent="() => updateFilters({ ...filters, statusId: '6', page: 1 })" href="#"
                              role="tab">
                              <span class="wx-st wx-st-potential" title="Potential">Potential</span>
                            </a>
                          </li>
                          </ul>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between gap-3 mb-2">
                      <div>
                          <div class="custom-dropdown rounded w-100 mb-2">
                        <div class="dropdown-btn-filter form-control" @click="toggleDropdownSearchArea">
                          <span>{{ selectedSearchArea || 'Select Field' }}</span>
                          <i class="icofont-rounded-down"></i>
                        </div>
                        <ul v-if="isDropdownSearchAreaOpen" class="dropdown-options-filters">
                          <li @click="selectSearchArea('title')">
                            Title
                          </li>
                          <li @click="selectSearchArea('clients')">
                            Clients
                          </li>
                        </ul>
                        </div>
                      </div>
                      <div class="w-100">
                        <input id="main-search-input-mobile" type="search" class="form-control rounded" placeholder="Αναζήτηση..."
                        aria-label="search" aria-describedby="addon-wrapping" />
                      </div>
                    </div>
                    <div class="w-100">
                      <div class="d-flex flex-column align-items-center mobileRows" v-for="(project, index) in data" :key="project.info.id"
                        :class="{ 'expired-row': project.info.expired }">
                        <div class="d-flex flex-column w-100">
                          <div class="d-flex align-items-center justify-content-between ">
                            <div class="d-flex align-items-center">
                              <div class="d-flex flex-column gap-1">
                                <div>
                                    <span class="current-code" :class="{ 'text-danger': project.info.expired }"
                                      @click="openInNewTab(getEntityType(project), project.info?.id)">
                                      <span class="badgeType fw-bold" v-if="project.info.type === 'project'">
                                        P
                                      </span>
                                      <span class="badgeType fw-bold" v-if="project.info.type === 'task'">
                                        T
                                      </span>
                                      <span class="badgeType fw-bold" v-if="project.info.type === 'subtask'">
                                        S
                                      </span>
                                      <span>{{ project.info?.title}}</span>
                                  </span>
                                </div>
                                <div>
                                  <span v-if="project.taskInfo" class="task-code"
                                    :class="{ 'disabled-link': !canAccessTask(project.taskInfo) }"
                                    @click="canAccessTask(project.taskInfo) && openInNewTab('task', project.taskInfo?.id)">
                                    <span class="badgeTypeSecondary fw-bold">T</span> <span>{{project.taskInfo?.title }}</span>
                                  </span>
                                </div>
                                <div>
                                  <span v-if="project.projectInfo" class="project-code"
                                    :class="{ 'disabled-link': !canAccessProject(project.projectInfo) }"
                                    @click="canAccessProject(project.projectInfo) && openInNewTab('project', project.projectInfo?.id)">
                                    <span class="badgeTypeSecondary fw-bold">P</span> <span>{{ project.projectInfo?.title }}</span>
                                  </span>
                                </div>
                              </div>
                              
                            </div>
                            <div class="d-flex align-items-center">
                              <span v-if="project.info.expired" class="badge bg-danger ms-2">Expired</span>
                              <div class="dropdown">
                                <button class="dropbtn"
                                  :style="{ backgroundColor: project.info.expired ? 'transparent' : '' }">
                                  <span class="wx-status-pill" :style="getStatusStyle(project.status.id)">{{ getCurrentStatus(project.status.id) }}</span>
                                  <i class="icofont-rounded-down" :style="{ color: getStatusColor(project.status.id) }"></i>
                                </button>
                                <div class="dropdown-content" v-if="project.info.type === 'project'">
                                  <button v-if="canEditProject(project) || canEditAllProjects || superUser"
                                    v-for="status in statuses" :key="status.id"
                                    @click="updateStatus(project.info?.id, status.id)">
                                    <span class="wx-status-pill" :style="getStatusStyle(status.id)">{{ getCurrentStatus(status.id) }}</span>
                                  </button>
                                </div>

                                <div class="dropdown-content" v-if="project.info.type === 'task'">
                                  <button v-if="canEditTask(project) || canEditAllTasks || superUser"
                                    v-for="status in statuses" :key="status.id"
                                    @click="updateStatus(project.info?.id, status.id)">
                                    <span class="wx-status-pill" :style="getStatusStyle(status.id)">{{ getCurrentStatus(status.id) }}</span>
                                  </button>
                                </div>

                                <div class="dropdown-content" v-if="project.info.type === 'subtask'">
                                  <button v-if="canEditSubTask(project) || canEditAllSubTasks || superUser"
                                    v-for="status in statuses" :key="status.id"
                                    @click="updateStatus(project.info?.id, status.id)">
                                    <span class="wx-status-pill" :style="getStatusStyle(status.id)">{{ getCurrentStatus(status.id) }}</span>
                                  </button>
                                </div>
                              </div>
                              <img class="avatar md rounded-circle img-thumbnail" v-if="project.manager?.avatar_file_name" :src="`/storage/avatars/${project.manager.avatar_file_name}`" width="25" style="border-radius:50%" :title="`${project.manager.username}`">
                              <p v-else>{{ project.manager?.username }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex w-100 gap-2 py-1 align-items-center text-secondary ps-1">
                          <div><i class="icofont-ui-calendar me-1"></i> {{ project.info?.startDate }}</div>
                          <div><i class="icofont-ui-calendar me-1"></i> {{ project.info?.endDate }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table id="projectTable" class="table-responsive table table-hover align-middle mb-0 mis_table" style="width:100%">
                  <thead>
                    <tr>
                      <th style="width:12%;">
                        <div class="justify-content-start">
                          Project/Task/Subtask
                          <i class="fa fa-sort sorting-icon" @click.prevent="sortBy(sortKeys.title)"></i>
                        </div>
                      </th>
                      <th style="width:12%;" v-if="filters.entity === 'tasks'">
                        <div>
                          Project
                          <i class="fa fa-sort sorting-icon" @click.prevent="sortBy(sortKeys.projectTitle)"></i>
                        </div>
                      </th>
                      <th style="width:12%;" v-else-if="filters.entity === 'subtasks'">
                        <div>
                          Task/Project
                          <i class="fa fa-sort sorting-icon" @click.prevent="sortBy(sortKeys.taskProjectTitle)"></i>
                        </div>
                      </th>
                      <th style="width:5%;">
                        <div>
                          Date
                          <i class="fa fa-sort sorting-icon" @click.prevent="sortBy(sortKeys.startDate)"></i>
                        </div>
                      </th>


                      <th style="width:5%;">
                        <div v-if="superUser" class="d-flex align-items-center">
                      
                          <div class="custom-dropdown">
                            <div class="dropdown-btn" @click="toggleDropdown">
                              <span>{{ selectedManager || 'Επιλογη Manager' }}</span>
                              <i class="icofont-rounded-down"></i>
                            </div>
                            <ul v-if="isDropdownOpen" class="dropdown-options">
                             <li @click="selectManager({ id: -1, username: 'All Managers' })">
                                All Managers <img src="../assets/images/icons8-superman.svg" alt="Citrine Logo" class="menu-img ms-2"
                            style="width:2em">
                              </li>
                             <li
  v-for="manager in managers"
  :key="manager.id"
  @click="selectManager(manager)"
>
  {{ manager.username }}
  
  <!-- Show superman icon unless it's the current user -->
  <img
    v-if="String(manager.id) !== currentUserId()"
    src="../assets/images/icons8-superman.svg"
    alt="Superman Icon"
    class="menu-img ms-2"
    style="width: 1.5em"
  />
</li>
                            </ul>
                          </div>
                        
                        </div>
                        <div v-else>
                          Manager
                          <i class="fa fa-sort sorting-icon" @click.prevent="sortBy('m.username')"></i>
                        </div>
                      </th>

                      <th style="width:5%;">
  <div v-if="superUser" class="d-flex align-items-center">
    <!-- Custom Dropdown for Creators -->
    <div class="custom-dropdown">
      <!-- Dropdown Button -->
      <div class="dropdown-btn" @click="toggleCreatorDropdown">
        <span>{{ selectedCreator || 'Επιλογη Creator' }}</span>
        <i class="icofont-rounded-down"></i>
      </div>

      <!-- Dropdown Options -->
      <ul v-if="isCreatorDropdownOpen" class="dropdown-options">
        <li @click="selectCreator({ id: -1, username: 'All Creators' })">
          All Creators
          <img
            src="../assets/images/icons8-superman.svg"
            alt="Citrine Logo"
            class="menu-img ms-2"
            style="width: 1.5em"
          />
        </li>
        <li
          v-for="creator in creators"
          :key="creator.id"
          @click="selectCreator(creator)"
        >
          {{ creator.username || creator.name}}
          <img
            v-if="String(creator.id) !== currentUserId()"
            src="../assets/images/icons8-superman.svg"
            alt="Superman Icon"
            class="menu-img ms-2"
            style="width: 1.5em"
          />
        </li>
      </ul>
    </div>
  </div>

  <div v-else>
    Creator
    <i class="fa fa-sort sorting-icon" @click.prevent="sortBy('creator.username')"></i>
  </div>
</th>



                      <th style="width:5%;" class="no-after">
                        <div>
                          Status
<!--                           <i class="fa fa-sort sorting-icon" @click.prevent="sortBy(sortKeys.statusId)"></i>
 -->                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(project, index) in data" :key="project.info.id"
                      :class="{ 'expired-row': project.info.expired }">

                      <td class="text-start">
                        <!-- Dynamically determine the link path based on entity type -->
                        <span class="current-code" :class="{ 'text-danger': project.info.expired }"
                          @click="openInNewTab(getEntityType(project), project.info?.id)">{{ project.info?.title
                          }}</span>
                        <span v-if="project.info.expired" class="badge bg-danger ms-2">Expired</span><br
                          v-if="project.projectInfo">

                        <!-- Display task title if taskInfo exists -->
                        <span v-if="project.taskInfo" class="task-code"
                          :class="{ 'disabled-link': !canAccessTask(project.taskInfo) }"
                          @click="canAccessTask(project.taskInfo) && openInNewTab('task', project.taskInfo?.id)">{{
                          project.taskInfo?.title }}</span><br v-if="project.taskInfo">

                        <!-- Dynamically determine the link path based on projectInfo -->
                        <span v-if="project.projectInfo" class="project-code"
                          :class="{ 'disabled-link': !canAccessProject(project.projectInfo) }"
                          @click="canAccessProject(project.projectInfo) && openInNewTab('project', project.projectInfo?.id)">
                          {{ project.projectInfo?.title }}
                        </span>
                      </td>


                      <td v-if="filters.entity === 'tasks'">
                        {{ project.projectInfo?.title }}
                      </td>
                      <td v-else-if="filters.entity === 'subtasks'">
                        {{ project.projectInfo?.title }} / {{ project.taskInfo?.title }}
                      </td>
                      <td class="textDate">{{ project.info?.startDate }} {{ project.info?.endDate }}</td>

                      <td v-if="project.manager?.avatar_file_name">
                        <img class="avatar md rounded-circle img-thumbnail"
                          :src="`/storage/avatars/${project.manager?.avatar_file_name}`" width="25"
                          :title="project.manager?.username">
                      </td>
                      <td v-if="!project.manager?.avatar_file_name">
                        {{ project.manager?.username }}
                      </td>

                      <td v-if="project.creator?.avatar_file_name">
                        <img class="avatar md rounded-circle img-thumbnail"
                          :src="`/storage/avatars/${project.creator?.avatar_file_name}`" width="25"
                          :title="project.creator?.username">
                      </td>
                      <td v-if="!project.creator?.avatar_file_name">
                        {{ project.creator?.username }}
                      </td>


                      <td>
                        <div class="dropdown">
                          <button class="dropbtn"
                            :style="{ backgroundColor: project.info.expired ? 'transparent' : '' }">
                            <span class="wx-status-pill" :style="getStatusStyle(project.status.id)">{{ getCurrentStatus(project.status.id) }}</span>
                            <i class="icofont-rounded-down" :style="{ color: getStatusColor(project.status.id) }"></i>
                          </button>
                          <div class="dropdown-content" v-if="project.info.type === 'project'">
                            <button v-if="canEditProject(project) || canEditAllProjects || superUser"
                              v-for="status in statuses" :key="status.id"
                              @click="updateStatus(project.info?.id, status.id, project.info.type)">
                              <span class="wx-status-pill" :style="getStatusStyle(status.id)">{{ getCurrentStatus(status.id) }}</span>
                            </button>
                          </div>

                          <div class="dropdown-content" v-if="project.info.type === 'task'">
                            <button v-if="canEditTask(project) || canEditAllTasks || superUser"
                              v-for="status in statuses" :key="status.id"
                              @click="updateStatus(project.info?.id, status.id, project.info.type)">
                              <span class="wx-status-pill" :style="getStatusStyle(status.id)">{{ getCurrentStatus(status.id) }}</span>
                            </button>
                          </div>

                          <div class="dropdown-content" v-if="project.info.type === 'subtask'">
                            <button v-if="canEditSubTask(project) || canEditAllSubTasks || superUser"
                              v-for="status in statuses" :key="status.id"
                              @click="updateStatus(project.info?.id, status.id, project.info.type)">
                              <span class="wx-status-pill" :style="getStatusStyle(status.id)">{{ getCurrentStatus(status.id) }}</span>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr class="col" v-if="!data || !data.length">
                      <td colspan="100">No data</td>

                    </tr>
                  </tbody>
                </table>

                <!-- Pagination -->
                <nav aria-label="Page navigation">
                  <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                    <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index"
                      :class="{ active: paginationLink.active }">
                      <router-link
                        :to="{ path: 'to-do', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
                        v-if="paginationLink.url">
                        <span class="page-link" v-html="paginationLink.label"></span>
                      </router-link>
                      <span class="page-link" v-else v-html="paginationLink.label"></span>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

            <!-- Filters Column -->
            <div class="col-md-3 rightCol " v-if="showFilters">
              <div class="card border-0 mb-2 mt-3">
                <!-- <div class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between">
                  <h3 class="fw-bold mb-0">Φίλτρα</h3>
                </div> -->
                


                  <!-- Entity Tabs -->
                  <ul class="nav nav-tabs tab-body-header rounded w-100 mb-2 justify-content-center" role="tablist">
                    <li class="nav-item">
                      <a :class="{
                        'nav-link text-center active': filters.entity == 'all' ,
                        'nav-link text-center': filters.entity != 'all',
                      }" @click.prevent="() => updateFilters({ ...filters, entity: 'all', page: 1 })" href="#"
                        role="tab">
                        <strong>All</strong>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a :class="{ 'nav-link text-center active': filters.entity == 'projects', 'nav-link text-center': filters.entity != 'projects' }"
                        @click.prevent="() => updateFilters({ ...filters, entity: 'projects', page: 1 })" href="#"
                        role="tab">
                        <strong>P</strong>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a :class="{ 'nav-link text-center active': filters.entity == 'tasks' || filters.entity == undefined, 'nav-link text-center': filters.entity != 'tasks' }"
                        @click.prevent="() => updateFilters({ ...filters, entity: 'tasks', page: 1 })" href="#"
                        role="tab">
                        <strong>T</strong>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a :class="{ 'nav-link text-center active': filters.entity == 'subtasks', 'nav-link text-center': filters.entity != 'subtasks' }"
                        @click.prevent="() => updateFilters({ ...filters, entity: 'subtasks', page: 1 })" href="#"
                        role="tab">
                        <strong>S</strong>
                      </a>
                    </li>
                  </ul>

                  <!-- Status Tabs -->
                  <ul class="nav nav-tabs tab-body-header rounded w-100 mb-2 justify-content-start" role="tablist">
                    <li class="nav-item">
                      <a :class="{ 'nav-link text-center active': filters.statusId == '10', 'nav-link text-center': filters.statusId != '10' && filters.statusId != undefined }"
                        @click.prevent="() => updateFilters({ ...filters, statusId: '10', page: 1 })" href="#"
                        role="tab">
                        All
                      </a>
                    </li>
                    
                    <li class="nav-item">
                      <a :class="{ 'nav-link text-center active': filters.statusId == '2' || filters.statusId == undefined, 'nav-link text-center': filters.statusId != '2'  && filters.statusId != undefined}"
                        @click.prevent="() => updateFilters({ ...filters, statusId: '2', page: 1 })" href="#"
                        role="tab">
                        <span class="wx-st wx-st-progress" title="In Progress">In progress</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a :class="{ 'nav-link text-center active': filters.statusId == '3', 'nav-link text-center': filters.statusId != '3' }"
                        @click.prevent="() => updateFilters({ ...filters, statusId: '3', page: 1 })" href="#"
                        role="tab">
                        <span class="wx-st wx-st-done" title="Done">Done</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a :class="{ 'nav-link text-center active': filters.statusId == '1', 'nav-link text-center': filters.statusId != '1' }"
                        @click.prevent="() => updateFilters({ ...filters, statusId: '1', page: 1 })" href="#"
                        role="tab">
                        <span class="wx-st wx-st-hold" title="On Hold">On hold</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a :class="{ 'nav-link text-center active': filters.statusId == '5', 'nav-link text-center': filters.statusId != '5' }"
                        @click.prevent="() => updateFilters({ ...filters, statusId: '5', page: 1 })" href="#"
                        role="tab">
                        <span class="wx-st wx-st-ongoing" title="On going">On going</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a :class="{ 'nav-link text-center active': filters.statusId == '4', 'nav-link text-center': filters.statusId != '4' }"
                        @click.prevent="() => updateFilters({ ...filters, statusId: '4', page: 1 })" href="#"
                        role="tab">
                        <span class="wx-st wx-st-archived" title="Archived">Archived</span>
                      </a>
                    </li>
                    <li v-if="filters.entity === 'projects'">
                      <a :class="{ 'nav-link text-center active': filters.statusId == '6', 'nav-link text-center': filters.statusId != '6' }"
                        @click.prevent="() => updateFilters({ ...filters, statusId: '6', page: 1 })" href="#"
                        role="tab">
                        <span class="wx-st wx-st-potential" title="Potential">Potential</span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="my-3 d-flex align-items-center">
                  <div class="me-2">
                    <input type="checkbox" id="expired" name="expired" class=" expired" @change="handleExpiredChange">
                  </div>
                  <div class="col-md-9 col-12">
                    <label for="expired" class="form-label">Ληγμένα - Σε εκκρεμότητα</label>
                  </div>
                </div>

                <div class="filter-section mt-3">
                  <div class="d-flex flex-column align-items-center mb-3">
                    <!-- <select class="ms-3 nav-link rounded me-2 selectSearch" v-model="searchArea">
                      <option value="title" selected>Title</option>
                      <option value="clients">Clients</option>
                    </select> -->
                    <div class="custom-dropdown w-100 shadow mb-2">
                      <div class="dropdown-btn-filter form-control" @click="toggleDropdownSearchArea">
                        <span>{{ selectedSearchArea || 'Select Field' }}</span>
                        <i class="icofont-rounded-down"></i>
                      </div>
                      <ul v-if="isDropdownSearchAreaOpen" class="dropdown-options-filters">
                        <!-- "All" Option to reset or select the default -->
                        <li @click="selectSearchArea('title')">
                          Title
                        </li>
                        <li @click="selectSearchArea('clients')">
                          Clients
                        </li>
                        <!-- Add more options as needed -->
                      </ul>
                    </div>
                    <input id="main-search-input" type="search" class="form-control" placeholder="Αναζήτηση..."
                      aria-label="search" aria-describedby="addon-wrapping" />
                  </div>

                <!-- Date Filters -->
                <div class="mb-3 d-flex flex-column">
                  <label for="start-date" class="form-label me-2">Start Date</label>
                  <input type="date" id="start-date" v-model="startDate" class="form-control w-auto" />
                </div>

                <div class="mb-3 d-flex flex-column">
                  <label for="end-date" class="form-label me-2">End Date</label>
                  <input type="date" id="end-date" v-model="endDate" class="form-control w-auto" />
                </div>

                

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="btn btn-toggle-filter" @click="toggleFilters">
    <i class="wx-ic wx-ic-filter" title="Toggle Filters"></i>
    <span class="text-white" style="writing-mode: sideways-lr;text-orientation: mixed;font-size: 18px;">Φίλτρα</span>
  </button>
</template>

<script>
import { defineComponent, ref, watch, computed, onMounted, onUnmounted } from 'vue';
import { useFetchData } from '@/composables/useFetchData';
import { fetchAll, fetchManagers, fetchStatusesForEntity, updateProjectStatus, updateTaskStatus, updateSubtaskStatus } from '@/services/todo';
import { useRoute, useRouter } from 'vue-router';
import { mapGetters } from 'vuex';
import { useToast } from 'vue-toastification';
import { statusStyle, STATUS_COLORS } from '@/status';

export default defineComponent({
  name: 'ToDo',
  data() {
    return {
      projectToArchive: null, // Store the project ID to be archived
      isGridView: false, // true for grid view, false for list view
      showFilters: true, // Track if filters are shown
    };
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters; // Toggle the filter display
    },
    canEditProject(project) {
      if (!project) { return false; }
      conso
      return localStorage.getItem('current_user_id') == project.info?.createdBy && this.userPermissions?.edit === 1;
    },
    canEditProjectManager(project) {
      if (!project) { return false; }
      return localStorage.getItem('current_user_id') == project.info?.managerId && this.userPermissions?.edit === 1;
    },
    openInNewTab(path, id) {
      const url = this.$router.resolve({ path, query: { id } }).href;
      window.open(url, '_blank');
    },
    canEditProject(project) {
      if (!project) { return false; }
      return localStorage.getItem('current_user_id') == project.createdBy && this.userPermissions?.edit === 1;
    },
    canViewProject(project) {
      if (!project) { return false; }
      return localStorage.getItem('current_user_id') == project.createdBy && this.userPermissions?.view === 1;
    },
    canEditTask(task) {
      if (!task) { return false; }
      return localStorage.getItem('current_user_id') == task.info?.createdBy && this.userPermissionsTasks?.edit === 1;
    },
    canEditSubTask(subtask) {
      if (!subtask) { return false; }
      return localStorage.getItem('current_user_id') == subtask.info?.createdBy && this.userPermissionsSubTasks?.edit === 1;
    },
    canViewTask(task) {
      if (!task) { return false; }
      return localStorage.getItem('current_user_id') == task.createdBy && this.userPermissions?.view === 1;
    },
    canAccessProject(projectInfo) {
      return this.superUser || this.canViewAllProjects || this.canViewProject(projectInfo);
    },
    canAccessTask(taskInfo) {
      return this.superUser || this.canViewAllTasks || this.canViewTask(taskInfo);
    },
     currentUserId(){
      return localStorage.getItem('current_user_id');
    },
    // Check if a given date has passed
    isExpired(endDate) {
      if (!endDate) return false; // If no end date, not expired
      const now = new Date();
      const end = new Date(endDate);
      return end < now; // Check if end date is in the past
    },
    getStatusColor(statusId) {
    return STATUS_COLORS[statusId] || 'gray';
    }
  },
  computed: {
    ...mapGetters({
      getUserPermission: 'getUserPermission',
      getSuperUserPermission: 'getSuperUserPermission',

    }),
    superUser() {
      return this.getSuperUserPermission === 1;
    },
    userPermissions() {
      return this.getUserPermission('Projects');
    },
    userPermissionsTasks() {
      return this.getUserPermission('Tasks');
    },
    userPermissionsSubTasks() {
      return this.getUserPermission('Subtasks');
    },
    canEditProjectCreator() {
      return this.userPermissions?.editCreator === 1;
    },
    canEditAllProjects() {
      return this.userPermissions?.editAll === 1;
    },
    canViewAllProjects() {
      return this.userPermissions?.viewAdmin === 1;
    },
    canEditAllTasks() {
      return this.userPermissionsTasks?.editAll === 1;
    },
    canEditAllSubTasks() {
      return this.userPermissionsSubTasks?.editAll === 1;
    },
    canViewAllTasks() {
      return this.userPermissionsTasks?.viewAdmin === 1;
    },


    canCreateProject() {
      return this.userPermissions?.create === 1;
    },
    canArchive() {
      return this.userPermissions?.archive === 1;
    },
    
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const toast = useToast();
    const searchArea = ref(route.query?.searchField || 'title');
    const startDate = ref(route.query?.startDate || '');
    const endDate = ref(route.query?.endDate || '');

    watch([searchArea], ([newSearchArea]) => {
      router.push({ path: '/to-do', query: { ...route.query, searchField: newSearchArea } });
    });
    watch([startDate, endDate], ([newStartDate, newEndDate]) => {
      router.push({ path: '/to-do', query: { ...route.query, startDate: newStartDate, endDate: newEndDate } });
    });

    const { data, paginationLinks, filters, updateFilters, fetchData, count, sortBy } = useFetchData(fetchAll, {
      page: route.query.page || 1,
      active: route.query.active || 1,
      archived: route.query.archived || 0,
      entity: route.query.entity || 'tasks',
      statusId: route.query.statusId || 2,
    });

    const creators = ref([]);
    // Managers and statuses
    const managers = ref([]);
    const statuses = ref([]);
    const selectedManager = ref('');
        const selectedCreator = ref('');
    const isDropdownOpen = ref(false);
        const isCreatorDropdownOpen = ref(false);
    const newStatusId = ref(null);

    // Create a reactive variable to track the expired checkbox state
    const expired = ref(false);

    // Handle expired checkbox change
    const handleExpiredChange = (event) => {
      expired.value = event.target.checked;

      // Update filters with expired: true or false based on the checkbox state
      updateFilters({
        ...filters.value, // Keep existing filters
        expired: expired.value ? 1 : 0, // Add expired filter
        page: 1, // Reset to page 1
      });
    };

    const fetchManagersData = async () => {
      try {
        const response = await fetchManagers();
        if (response.data.success) {
          managers.value = response.data.data;
        } else {
          console.error("Failed to fetch managers:", response.data.message);
        }
      } catch (error) {
        console.error("Failed to fetch managers:", error);
      }
    };

    const fetchCreatorsData = async () => {
      try {
        const response = await fetchManagers();
        if (response.data.success) {
          creators.value = response.data.data;
        } else {
          console.error("Failed to fetch creators:", response.data.message);
        }
      } catch (error) {
        console.error("Failed to fetch creators:", error);
      }
    };

    const fetchStatuses = async () => {
      const entityType = filters.value.entity || 'tasks'; // Ensure default fallback
      try {
        const response = await fetchStatusesForEntity(entityType);
        if (response && response.data && response.data.statuses) {
          statuses.value = response.data.statuses;
          console.log('Statuses updated:', statuses.value); // Debugging log
        } else {
          console.error('Failed to fetch statuses: Response does not contain statuses');
        }
      } catch (error) {
        console.error('Error fetching statuses:', error);
      }
    };


    // const updateStatus = async (entityId, statusId) => {
    //   try {
    //     let response;
    //     if (filters.value.entity === 'projects') {
    //       response = await updateProjectStatus(entityId, statusId);
    //     } else if (filters.value.entity === 'tasks') {
    //       response = await updateTaskStatus(entityId, statusId);
    //     } else if (filters.value.entity === 'subtasks') {
    //       response = await updateSubtaskStatus(entityId, statusId);
    //     }
    //     if (response.data.success) {
    //       toast.success(response.data.message);
    //       fetchData();
    //     } else {
    //       toast.error(response.data.message);
    //     }
    //   } catch (error) {
    //     console.error("Failed to update status:", error);
    //     toast.error("Failed to update status.");
    //   }
    // };

    const updateStatus = async (entityId, statusId, entityType = filters.value.entity) => {
      try {
        let response;
        switch (entityType) {
          case 'project':
          case 'projects':
            response = await updateProjectStatus(entityId, statusId);
            break;
          case 'task':
          case 'tasks':
            response = await updateTaskStatus(entityId, statusId);
            break;
          case 'subtask':
          case 'subtasks':
            response = await updateSubtaskStatus(entityId, statusId);
            break;
          default:
            response = await updateTaskStatus(entityId, statusId);
            break;
        }

        if (response.data.success) {
          toast.success(response.data.message);
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error('Failed to update status:', error);
        toast.error('Failed to update status.');
      }
    };

    // const updateManagerFilter = (event) => {
    //   const newManagerId = event.target.value;
    //   updateFilters({ ...filters.value, managerFilter: newManagerId, page: 1 });
    // };

    const updateManagerFilter = (managerId) => {
      // Now, managerId is passed directly from the selectManager method
      updateFilters({ ...filters.value, managerFilter: managerId, page: 1 });
    };

    const updateCreatorFilter = (creatorId) => {
      updateFilters({ ...filters.value, creatorFilter: creatorId, page: 1 });
    };

    

    // Function to toggle the visibility of the dropdown
    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const toggleCreatorDropdown = () => {
      isCreatorDropdownOpen.value = !isCreatorDropdownOpen.value;
    };

    // Function to handle manager selection
    const selectManager = (manager) => {
      selectedManager.value = manager.username;
      isDropdownOpen.value = false;  // Close the dropdown after selection
      updateManagerFilter(manager.id); // Call your update manager filter function
    };
    const selectCreator = (creator) => {
      selectedCreator.value = creator.username;
      isCreatorDropdownOpen.value = false;  // Close the dropdown after selection
      updateCreatorFilter(creator.id); // Call your update manager filter function
    };

    const getStatusIcon = (id) => {
      const status = statuses.value.find(s => s.id === id);
      return status ? require(`@/assets/images/${status.img}`) : '';
    };

    const getStatusStyle = (id) => statusStyle(id, 'min-width:7.5em;');

    const getCurrentStatus = (id) => {
      const status = statuses.value.find(s => s.id === id);
      return status ? status.description : 'Select Status';
    };


    const sortKeys = ref({
      title: 'projects.description',
      startDate: 'projects.startDate',
      endDate: 'projects.endDate',
      statusId: 'projects.statusId'
    });

    watch(filters, (newFilters, oldFilters) => {
      if (newFilters.entity !== oldFilters.entity) {
        sortKeys.value = {
          title: `${newFilters.entity}.title`,
          startDate: `${newFilters.entity}.startDate`,
          endDate: `${newFilters.entity}.endDate`,
          statusId: `${newFilters.entity}.statusId`,
        };
        fetchStatuses(); // Called when entity changes to update statuses.
      }
    }, { deep: true });

    // Determine entity type for routing
    const getEntityType = (project) => {
      if (filters.value.entity === 'tasks') {
        return 'task';
      } else if (filters.value.entity === 'subtasks') {
        return 'subtask';
      } else if (filters.value.entity === 'projects') {
        return 'project';
      } else {
        // Check project type for unknown entity
        if (project.info?.type === 'subtask') {
          return 'subtask';
        } else if (project.info?.type === 'task') {
          return 'task';
        } else if (project.info?.type === 'project') {
          return 'project';
        } else {
          return 'unknown'; // Default fallback if type is unknown
        }
      }
    };

    const getPageFromUrl = (url) => url ? new URL(url, window.location.origin).searchParams.get('page') : null;

    // This is the ref for search area (title, clients, etc.)
    const selectedSearchArea = ref(searchArea.value);
    
    // For controlling dropdown visibility
    const isDropdownSearchAreaOpen = ref(false);

    // Toggle dropdown visibility
    const toggleDropdownSearchArea = () => {
      isDropdownSearchAreaOpen.value = !isDropdownSearchAreaOpen.value;
    };

    // Select a search field option
    const selectSearchArea = (value) => {
      selectedSearchArea.value = value;
      searchArea.value = value;
      isDropdownSearchAreaOpen.value = false;
      
      // Update the route query to reflect the selected value
      router.push({
        path: '/to-do',
        query: { ...route.query, searchField: value },
      });
    };

    const searchAction = () => {
      setTimeout(() => {
        router.push({ path: '/to-do', query: { ...route.query, search: $("#main-search-input").val(), searchField: searchArea.value } });
      }, 300);
    };

    onMounted(() => {
      $("#main-search-input").val(route.query?.search || '');
      $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
      fetchManagersData();
      fetchCreatorsData();
      fetchStatuses();

     
    });

    onUnmounted(() => {
      $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
    });

    return { data, paginationLinks, filters, updateFilters, fetchData, count, sortBy, startDate, endDate, getPageFromUrl, managers, creators, statuses, updateStatus, handleExpiredChange, updateManagerFilter, updateCreatorFilter, getStatusStyle, getStatusIcon, getCurrentStatus, searchArea, sortKeys, getEntityType, selectedSearchArea, isDropdownSearchAreaOpen, toggleDropdownSearchArea,selectSearchArea, searchAction, selectManager, selectCreator, selectedManager, selectedCreator, isDropdownOpen, isCreatorDropdownOpen, toggleDropdown, toggleCreatorDropdown};
  },
});
</script>

<style scoped>
.project-code {
  font-weight: bold;
}

.form-select {
  margin-top: 5px;
  width: auto;
}

/* Dropdown styling for status selection */
.dropdown {
  position: relative;
  display: inline-block;
}

.dropbtn {
  padding: 8px 12px;
  font-size: 14px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color:transparent;
}

.dropdown-content {
  display: none;
  position: absolute;
  width: fit-content;
  box-shadow: 0px 0px 10px 2px #dedede;
  z-index: 1;
  border-radius: 8px;
  background: #fff;
}

.dropdown-content button {
  background: transparent;
  padding: 7px;
  width: 100%;
  border: none;
  cursor: pointer;
  text-align: left;
}

.dropdown-content button:hover {
  background-color: transparent;
  transform: scale(1.6);
  transition: .5s;
}


.dropdown:hover .dropdown-content {
  display: flex;
  right: 0;
}
.dropdown:hover .icofont-rounded-down {
  transform: rotate(180deg);
  transition: .8s;
}

.current-code {
  font-size: 1.1em;
  cursor: pointer;
}

.project-code,
.task-code {
  color: #A7A7A7;
  font-size: small;
  cursor: pointer;

}

.expired-row {
  /* background-color: #e7e7e7; */
  /* opacity: 0.5; */
  /* box-shadow: inset 0px 0px 25px 0px #dedede; */
  border-radius: 0px;
}
.expired-row .current-code{
  opacity: 0.5;
}
.expired-row .project-code{
  opacity: 0.5;
}
.expired-row .task-code{
  opacity: 0.5;
}

.expired-row .textDate{
  opacity: 0.5;
}

.expired-row:hover .textDate{
  background: #ececec;
}

.text-danger {
  color: #dc3545 !important;
  /* Highlight text in red */
}

.badge.bg-danger {
  background-color: #dc3545;
  /* Bootstrap danger badge color */
  color: white;
  font-size: 0.75em;
  padding: 0.25em 0.5em;
  border-radius: 0.25rem;
  margin-left: 6px;
}

.btn-toggle-filter {
  position: fixed;
  right: 0px;
  top: 42%;
  z-index: 9999;
  padding: 20px 2px;
  background-color: var(--secondary-color);
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  letter-spacing: 1px;
}

.btn-toggle-filter:hover {
  background-color: #444444;
  transition: 0.5s;
}
.dropdown-btn-filter{
  cursor: pointer;
  text-transform: capitalize;
  font-weight: 600;
  color: #545454;
}
.dropdown{
  position: relative;
  display: inline-block;
}


.dropdown-btn {
    cursor: pointer;
}

/* Dropdown Options List */
.dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options-filters {
    position: absolute;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: fit-content;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options li,
.dropdown-options-filters li {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #545454;
    font-weight: 600;
    border-bottom: 1px dashed lightgray;
}

.dropdown-options li:hover,
.dropdown-options-filters li:hover {
    background-color: #545454;
    color: white;
}
/* Dropdown Options List */

#projectTableMobile{
  display: none !important;
}

.nav-link.active{
  min-width: 25px;
}
@media screen and (max-width: 1279px) {
  #projectTable{
    display: none;
  }
  #projectTableMobile{
    display: flex !important;
  }
  .btn-toggle-filter{
    display: none;
  }
  .mobileRows{
    padding: 5px 10px;
    border-bottom: 1px dashed #dedede;
    margin-bottom: 12px;
  }
  .expired-row{
    box-shadow: none;
  }
  .badgeType{
    font-size: 16px;
    background: #777;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    min-width: 22px;
    height: 22px;
    border-radius: 99px;
  }
  .badgeTypeSecondary{
    font-size: 12px;
    background: #777;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    min-width: 18px;
    height: 18px;
    border-radius: 99px;
    margin-left: 1.35px;
  }
  .current-code, .project-code, .task-code{
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    word-break: break-word;
  }
  .date-input {
      position: absolute;
      opacity: 0;
      width: 2em; /* Small width to keep it clickable */
      cursor: pointer;
    }

    .calendar-icon {
      font-size: 1.5em;
      cursor: pointer;
    }
    .nav-tabs .nav-link{
      padding: 5px;
    }
  .dropdown-btn-filter{
    width: 100px;
  }
}
</style>